import { Map } from 'immutable';

export const DefaultServices = Map({
    'first-property': Map({
        id: 392,
        name: 'Buying my first property',
        label: 'Finding the best mortgage advice',
        title: 'Find the best adviser to help <span class="line">with your mortgage</span>',
        description: 'to help with mortgage advice',
    }),
    remortgaging: Map({
        id: 392,
        name: 'Remortgaging',
        label: 'Finding the best mortgage advice',
        title: 'Find the best adviser to help <span class="line">with your mortgage</span>',
        description: 'to help with mortgage advice',
    }),
    'additional-property': Map({
        id: 392,
        name: 'Buying a new property',
        label: 'Finding the best mortgage advice',
        title: 'Find the best adviser to help <span class="line">with your mortgage</span>',
        description: 'to help with mortgage advice',
    }),
});



// WEBPACK FOOTER //
// ./src/constants/DefaultServices.js